<template>
  <div>
    <template v-if="invitations.length > 0">
      <div
        v-for="invitation in invitations"
        :key="invitation.id"
        class="mb-16 base-card-wrapper"
      >
        <div class="sub-card-wrapper">

          <BaseListItemCard size="sm" class="grid grid-cols-12 gap-4 items-center">
            <div style="margin-top: 22px" class="col-span-12 grid grid-cols-12 gap-4 items-center">
              <div
                class="col-span-7 md:col-span-7 lg:col-span-7 xl:col-span-7 2xl:col-span-7 flex flex-col justify-center whitespace-nowrap truncate space-x-4">
      <span class="text-base-p-md">
        {{ invitationText(invitation) }}
      </span>
              </div>
              <div class="col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2 2xl:col-span-2 flex items-center">
                <InlineSvg class="svg-sm mr-5" src="/img/clock.svg" />
                {{ invitation.createdAt }}
              </div>
              <div
                class="invitation-nav col-span-1 md:col-span-1 lg:col-span-1 xl:col-span-1 2xl:col-span-1 flex items-center justify-end">
                <button
                  @click="$emit('confirm', getTargetId(invitation))"
                  type="button"
                  class="green-5-color mr-2"
                >
                  <i class="icon invitation-success-icon"></i>
                  {{ $t("form.button.accept") }}
                </button>
                <button
                  @click="$emit('unconfirm', getTargetId(invitation))"
                  type="button"
                  class="red-5-color"
                >
                  <i class="icon invitation-cancel-icon"></i>
                  {{ $t("form.button.reject") }}
                </button>
              </div>
            </div>
            <div style="margin-top: -12px; margin-bottom: 12px" class="col-span-12 grid grid-cols-12 gap-4 items-center">
              <div
                class="col-span-7 md:col-span-7 lg:col-span-7 xl:col-span-7 2xl:col-span-7 flex flex-col justify-center whitespace-nowrap truncate space-x-4">
                  <span class="text-base-p-sm">
                    <span class="orange-1-color" >{{ $t('invitation.expires_soon') }}</span> <span>{{invitation.validUntilAt}}</span>
                  </span>
              </div>
            </div>
          </BaseListItemCard>


        </div>
      </div>
    </template>

    <template v-else>
      <div  class="grey-4-color">
        {{ emptyText }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "InvitationList",
  props: {
    invitations: {
      type: Array,
      required: true
    },
    emptyText: {
      type: String,
      default: ""
    },
    isLoad: Boolean,
    type: {
      type: String,
      required: true,
      validator: value => ["contract", "counterparty"].includes(value)
    }
  },
  emits: ["confirm", "unconfirm"],
  methods: {
    invitationText(invitation) {
      const params = {
        user: invitation.invitingUser.fullName,
        [this.type]: invitation[`${this.type}Name`]
      };
      return this.$t(`invitation.user_invite_to_${this.type}`, params);
    },
    getTargetId(invitation) {
      return invitation[`${this.type}Id`];
    }
  }
};
</script>


<style lang="scss" scoped>
.invitation-nav {
  display: flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;
  padding-left: 20px;

  button {
    padding: 0;
    border: none;
    margin: 0 22px 0 0;
    background: transparent;
    display: flex;
    align-items: center;

    &:last-child {
      margin-right: 0;
    }

    &:focus {
      outline: none;
    }

    .icon {
      margin-right: 8px;
    }
  }
}

.text-base-p-md {
  white-space: normal;
  overflow-wrap: break-word;
}

@media screen and (max-width: 992px) {
  .cabinet-list_item {
    display: block;
  }

  .invitation-nav {
    padding-left: 0;
    justify-content: space-between;
    width: 100%;
    margin-top: 15px;
  }
}
</style>